import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

// ----------------------------------------------------------------------

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json']
});

const isBrowser = typeof window !== "undefined"
if (isBrowser)
{
  window.hljs = hljs;
}

